import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const navigation = {
    main: [
      { name: 'Home', path: '/' },
      { name: 'About', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Contact', path: '/contact' },
    ],
    services: [
      'TV Mounting',
      'Smart TV Setup',
      'Universal Remote Setup',
      'Home Theater Installation',
    ],
    contact: [
      { text: 'Phone: (815) 625-8453', href: 'tel:+18156258453' },
      { text: 'Email: info@wisetvsetup.info', href: 'mailto:info@wisetvsetup.info' },
      { text: '311 E 29th St', href: 'https://maps.google.com' },
      { text: 'Sterling, Illinois(IL), 61081', href: 'https://maps.google.com' },
    ],
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container>
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              TV Setup & Activation
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Professional TV installation and setup services for your home and
              business. We make technology work for you.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', '&:hover': { color: 'secondary.main' } }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', '&:hover': { color: 'secondary.main' } }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', '&:hover': { color: 'secondary.main' } }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', '&:hover': { color: 'secondary.main' } }}
              >
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              {navigation.main.map((item) => (
                <Box component="li" key={item.name} sx={{ mb: 1 }}>
                  <Link
                    component={RouterLink}
                    to={item.path}
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      '&:hover': { color: 'secondary.main' },
                    }}
                  >
                    {item.name}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Services
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              {navigation.services.map((service) => (
                <Box component="li" key={service} sx={{ mb: 1 }}>
                  <Link
                    component={RouterLink}
                    to="/services"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      '&:hover': { color: 'secondary.main' },
                    }}
                  >
                    {service}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Contact Info
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              {navigation.contact.map((item) => (
                <Box component="li" key={item.text} sx={{ mb: 1 }}>
                  <Link
                    href={item.href}
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      '&:hover': { color: 'secondary.main' },
                    }}
                  >
                    {item.text}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />

        <Typography variant="body2" align="center">
          © {new Date().getFullYear()} TV Setup & Activation. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 